import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { gold, greyBlue } from '../../assets/colors.js';
import { Montserrat } from '../../assets/fonts.js';
import getPgaTld from '../../getPgaTld.js';
import handleMailClick from '../HeaderMailModal/handleMailClick.js';
import Subnav from './Subnav.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var LinkCss = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: #fff;\n  text-decoration: none;\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 15px;\n  width: 100%;\n  flex-grow: 45;\n  position: relative;\n\n  &.active {\n    font-weight: 700;\n  }\n\n  &.active::before {\n    content: \"\";\n    position: absolute;\n    vertical-align: middle;\n    width: 100%;\n    color: ", ";\n    left: ", "px;\n    right: ", "px;\n    bottom: ", "px;\n    border-bottom: 4px solid;\n    @media (max-width: 992px) {\n      bottom: -5px;\n    }\n  }\n\n  &.active:hover {\n    text-decoration: none;\n    color: #fff;\n  }\n  &:hover {\n    text-decoration: none;\n    color: ", ";\n  }\n"])), Montserrat, gold, function (props) {
  return props.l;
}, function (props) {
  return props.r;
}, function (props) {
  return props.b;
}, gold);
var LinkFrame = styled.a.attrs(function (props) {
  return {
    href: props.to,
    rel: function rel(props) {
      return props.external ? "noopener noreferrer" : null;
    }
  };
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n"])), LinkCss);
var EmailText = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  cursor: pointer;\n"])), LinkCss);
var NavFrame = styled.nav(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  width: 100%;\n  flex-grow: 1;\n  white-space: nowrap;\n"])), function (props) {
  return props.vertical && "column" || "row";
});
var pgaTld = getPgaTld();
var RedirectToLogin = function RedirectToLogin(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/React__default.createElement(EmailText, {
    onClick: function onClick() {
      return window.location.assign("https://account.".concat(pgaTld, "/login?return_to=https://account.").concat(pgaTld, "/mail-redirect"));
    }
  }, label);
};
var mapLinks = function mapLinks(options, comp, vertical, b, l, _ref2) {
  var isLoggedIn = _ref2.isLoggedIn,
    meEmailMigrationData = _ref2.meEmailMigrationData,
    setModalType = _ref2.setModalType,
    setOpen = _ref2.setOpen;
  return options && options.map(function (option) {
    var to = option.to,
      _option$label = option.label,
      label = _option$label === void 0 ? "" : _option$label,
      target = option.target,
      root = option.root,
      external = option.external;
    var LinkComponent = comp && !external ? comp : LinkFrame;
    return /*#__PURE__*/React__default.createElement(LinkBox, {
      key: label,
      vertical: vertical
    }, option.options ? /*#__PURE__*/React__default.createElement(Subnav, {
      option: option,
      comp: comp
    }) : label.toLowerCase() === "my email" ? !isLoggedIn ? /*#__PURE__*/React__default.createElement(RedirectToLogin, {
      label: label
    }) : /*#__PURE__*/React__default.createElement(EmailText, {
      onClick: function onClick() {
        return handleMailClick({
          meEmailMigrationData: meEmailMigrationData,
          setModalType: setModalType,
          setOpen: setOpen
        });
      }
    }, label) : /*#__PURE__*/React__default.createElement(LinkComponent, {
      exact: true,
      key: to,
      to: to,
      target: target,
      b: b,
      l: l,
      className: "".concat(root && "active", " pga-nav"),
      external: external
    }, label));
  });
};
var LinkBox = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding: 15px 10px;\n  @media (min-width: 992px) {\n    padding: 10px 10px;\n  }\n  @media (min-width: 1200px) {\n    padding: 10px 15px;\n  }\n  ", "\n"])), function (props) {
  return props.vertical && "\n    &:not(:last-child) {\n      border-bottom: 2px solid ".concat(greyBlue, ";\n    }\n  ");
});

export { EmailText, LinkBox, LinkFrame, NavFrame, RedirectToLogin, mapLinks };
